module.exports = __webpack_public_path__ + "media/images/icon__minus@2x-718f3b0f89130205f4a9754ec8200cff.png";